export default __webpack_public_path__ + "6737dce5c37564aca4d2e6ef72d7f967.svg";